"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.interpolateClientReminderEmailTemplate = void 0;
const _ = require("lodash");
const interpolateTemplate = (template, context) => {
    return _.template(template, { interpolate: /{{([\s\S]+?)}}/g, evaluate: /\[\%([\s\S]+?)\%\]/g })(context);
};
const interpolateClientReminderEmailTemplate = (template, data) => {
    const context = Object.assign({}, data);
    return interpolateTemplate(template, context);
};
exports.interpolateClientReminderEmailTemplate = interpolateClientReminderEmailTemplate;
//# sourceMappingURL=interpolate-client-reminder-template.js.map